import { render, staticRenderFns } from "./SpecialEvents.vue?vue&type=template&id=7a65ec73&scoped=true&"
import script from "./SpecialEvents.vue?vue&type=script&lang=js&"
export * from "./SpecialEvents.vue?vue&type=script&lang=js&"
import style0 from "./SpecialEvents.vue?vue&type=style&index=0&id=7a65ec73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65ec73",
  null
  
)

export default component.exports